import {Record} from 'immutable';

const Center = Record({
    id: null,
    name: null,
    serial: null,
});

export default Center;



// WEBPACK FOOTER //
// src/domain/Center.js